import React, { useEffect } from "react";
import { Button, Input } from "antd";
import useFindReplace from "../../../../hooks/useFindReplace";
import { TranscriptionBlockType } from "../../../../utils/type";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { useAppDispatch } from "../../../../redux/useAppDispatch";
import { addFindHistory, closeFindReplace, setReplaceText, setSearchQuery } from "../../../../redux/JobModule/QCDetailPage/QCDetailPageAction";
import { Icon } from "@fluentui/react";
import SelectAfter from "./SelectAfter";
import SelectFindDropdown from "./SelectFindDropdown";
import SelectReplaceDropdown from "./SelectReplaceDropdown";

interface Props {
  texts: TranscriptionBlockType[];
  type: string;
  editorRef: React.MutableRefObject<any>;
}

const ControlPanel: React.FC<Props> = (props: Props) => {
  const { findMatches, handleNext, handlePrev, handleReplace, handleReplaceAll } = useFindReplace(props.texts, props.type, props.editorRef);
  const dispatch = useAppDispatch();
  const replaceAllLoading = useSelector((state: RootState) => state.qCDetailPageState.replaceAllLoading);
  const replaceText = useSelector((state: RootState) => state.qCDetailPageState.replaceText);
  const searchQuery = useSelector((state: RootState) => state.qCDetailPageState.searchQuery);
  const allMatches = useSelector((state: RootState) => state.qCDetailPageState.allMatches);
  const currentMatchIndex = useSelector((state: RootState) => state.qCDetailPageState.currentMatchIndex);
  const findHistory = useSelector((state: RootState) => state.qCDetailPageState.findHistory);
  const setSearchQueryValue = (searchQuery: string) => {
    dispatch(setSearchQuery(searchQuery));
  };
  const setReplaceTextValue = (replaceText: string) => {
    dispatch(setReplaceText(replaceText));
  };

  useEffect(() => {
    findMatches(searchQuery);
  }, [searchQuery]);

  return (
    <div className="d-flex flex-row justify-content-between align-items-center gap-2 mt-3">
      <div className="d-flex flex-row gap-2">
        <div className="d-flex flex-column gap-2">
          <div>
            <div className="d-flex gap-2 align-items-center">
              <Input
                placeholder="Find"
                allowClear
                style={{ width: 300 }}
                //   addonBefore={selectBeforeSearch}
                value={searchQuery}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleNext();
                    const value = (e.target as HTMLInputElement).value;
                    if (value !== findHistory[0]) {
                      dispatch(addFindHistory(value));
                    }
                  }
                }}
                onChange={(e) => {
                  setSearchQueryValue(e.target.value);
                  // findMatches(e.target.value);
                }}
                addonBefore={<SelectFindDropdown setSearchQueryValue={setSearchQueryValue} />}
                suffix={<SelectAfter />}
              />
              <div className="d-flex gap-3 align-items-center">
                {allMatches.length > 0 ? (
                  <span>
                    {currentMatchIndex + 1} \ {allMatches.length}
                  </span>
                ) : (
                  <span>No result</span>
                )}

                <Icon
                  iconName="Down"
                  onClick={handleNext}
                  className="icon-action"
                  style={{ fontSize: 20 }}
                />

                <Icon
                  iconName="Up"
                  className="icon-action"
                  onClick={handlePrev}
                  style={{ fontSize: 20 }}
                />
              </div>
            </div>
          </div>
          <div className="d-flex  gap-2">
            <Input
              placeholder="Replace with..."
              value={replaceText}
              allowClear
              addonBefore={<SelectReplaceDropdown setReplaceTextValue={setReplaceTextValue} />}
              onChange={(e) => setReplaceTextValue(e.target.value)}
              style={{ marginBottom: "10px", width: 300 }}
            />
            <div
              className="d-flex gap-1"
              style={{ marginBottom: "10px" }}>
              <Button
                loading={replaceAllLoading}
                disabled={allMatches.length === 0}
                onClick={handleReplaceAll}>
                Replace All
              </Button>
              <Button
                onClick={handleReplace}
                disabled={allMatches.length === 0}>
                Replace
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end align-items-center">
        <Icon
          onClick={() => {
            dispatch(closeFindReplace());
            dispatch(setReplaceText(""));
            dispatch(setSearchQuery(""));
            findMatches("");

          }}
          iconName="ChromeClose"
          className="icon-action"
          style={{ fontSize: 20 }}
        />
      </div>
    </div>
  );
};

export default ControlPanel;
